import React, { useEffect } from "react";
import { useSelector } from 'react-redux';

import commonComponents from "../../components/common";

import common from "../../utils/common";
import global from "../../config/global";

const Register = () => {
  const { BusyOverlay } = commonComponents;
  const locale = useSelector((state) => state.system.locale);

  const query = common.convertStringToQuery(window.location.search);

  useEffect(() => {
    window.location.replace(`${global.urls.LOCKER_ID_URL}/register?SERVICE_URL=/&SERVICE_SCOPE=${global.constants.SERVICE_SCOPE}&ENVIRONMENT=${global.constants.ENVIRONMENT}&lang=${query?.lang || locale}`)
  }, [locale])
  return (
    <div className="auth-page">
      <BusyOverlay />
    </div>
  );
}

export default Register;